enum SpecialtyPredictionModelEnum {
  All = "All",
  Match = "Match",
  Mismatch = "Mismatch"
}

export { SpecialtyPredictionModelEnum };